webpackJsonp([80],{

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(48);

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[47]);


// WEBPACK FOOTER //
// m-breadcrumb.js